import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Radio } from 'antd';

import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';

import { getCropName } from '../../utils/crops';
import { updateSorting } from '../../store/slices/sensors';
import { FilterParametersDefault, OrderAscValue, OrderDesValue } from './constants/index.jsx';
import { useViewport } from '../../hooks';
import { BreakpointMobileUp } from '../../constants/ui';
import { getFilterParametersMap } from '../../utils/filter';

const Filter = ({ t, workspaceCrops, parameters = FilterParametersDefault, onClickApply }) => {
  const dispatch = useDispatch();
  const { widthViewport } = useViewport();
  const [searchParams, setSearchParams] = useSearchParams();
  const FilterParametersMap = getFilterParametersMap(t)

  const {
    sorting: { dir, parameter, crop },
  } = useSelector((state) => state.sensors);

  const [filterOrder, setFilterOrder] = useState(dir === '-' ? OrderDesValue : OrderAscValue);

  const onChangeOrder = ({ target: { value } }) => {
    dispatch(updateSorting({ dir: value === OrderAscValue ? '' : '-', parameter, crop }));
    searchParams.set('sort', `${value === OrderAscValue ? '' : '-'}${parameter}`);
    setSearchParams(searchParams);
    setFilterOrder(value);
  };

  const onChangeParameter = ({ target: { value } }) => {
    dispatch(updateSorting({ dir, parameter: value, crop }));
    searchParams.set('sort', dir + value);
    setSearchParams(searchParams);
  };

  const onChangeCrop = ({ target: { value } }) => {
    dispatch(updateSorting({ dir, parameter, crop: value }));
  };

  // const onApplyFilter = ({ orderValue }) => {
  //   dispatch(updateSorting({ dir: orderValue === OrderAscValue ? '' : '-', parameter, crop: filterCrop }));
  //   onClickApply();
  // };
  //
  // const onClearFilter = () => {
  //   setFilterCrop('all');
  //   setFilterOrder(dir === '-' ? OrderDesValue : OrderAscValue);
  // };

  return (
    <div className={styles.filter}>
      {/*Order*/}
      <Radio.Group
        defaultValue={filterOrder}
        value={filterOrder}
        buttonStyle="solid"
        optionType="button"
        onChange={onChangeOrder}
        className={`${styles.radioButtonGroup} ${styles.radioButtonGroupWide}`}
        size={widthViewport < BreakpointMobileUp ? 'large' : null}
      >
        <Radio.Button
          value={OrderAscValue}
          className={`${styles.radioButton} ${filterOrder === OrderAscValue ? styles.radioButtonChecked : ''}`}
        >
          <span className={styles.radioButtonText}>
            <CroplerIcon name="asc" />
            {t('filters.ascending')}
          </span>
        </Radio.Button>
        <Radio.Button
          value={OrderDesValue}
          className={`${styles.radioButton} ${filterOrder === OrderDesValue ? styles.radioButtonChecked : ''}`}
        >
          <span className={styles.radioButtonText}>
            <CroplerIcon name="desc" />
            {t('filters.descending')}
          </span>
        </Radio.Button>
      </Radio.Group>

      {/*Parameters*/}
      {parameters.length > 0 && (
        <Radio.Group
          defaultValue={parameter}
          buttonStyle="solid"
          optionType="button"
          className={`${styles.radioButtonGroup}`}
          onChange={onChangeParameter}
          size={widthViewport < BreakpointMobileUp ? 'large' : null}
        >
          {parameters.map((item) => {
            const { Icon, label } = FilterParametersMap[item];
            return (
              <Radio.Button
                key={item}
                value={item}
                className={`${styles.radioButton} ${parameter === item ? styles.radioButtonChecked : ''}`}
              >
                <span className={styles.radioButtonText}>
                  <Icon />
                  {label}
                </span>
              </Radio.Button>
            );
          })}
        </Radio.Group>
      )}

      {/*Crops*/}
      {workspaceCrops && widthViewport < BreakpointMobileUp && (
        <Radio.Group
          defaultValue={crop}
          value={crop}
          buttonStyle="solid"
          optionType="button"
          onChange={onChangeCrop}
          className={`${styles.radioButtonGroup}`}
          size={widthViewport < BreakpointMobileUp ? 'large' : null}
        >
          <Radio.Button
            value="all"
            className={`${styles.radioButton} ${crop === 'all' ? styles.radioButtonChecked : ''}`}
          >
            <span className={styles.radioButtonText}>
              <CroplerIcon name="crops" />
              {t('crops.all')}
            </span>
          </Radio.Button>
          {workspaceCrops.map((c) => (
            <Radio.Button
              key={c.id}
              value={c.id}
              className={`${styles.radioButton} ${c.id === crop ? styles.radioButtonChecked : ''}`}
            >
              <span className={`${styles.radioButtonText} text-capitalize`}>
                <CroplerIcon name="plant" />
                {getCropName({ t, id: c.id })}
              </span>
            </Radio.Button>
          ))}
        </Radio.Group>
      )}

      {/*<div className={styles.filterNav}>*/}
      {/*  <Button type="secondary" onClick={onClearFilter}>*/}
      {/*    Clear All*/}
      {/*  </Button>*/}
      {/*  <Button type="primary" onClick={() => onApplyFilter({ orderValue: filterOrder })}>*/}
      {/*    Apply*/}
      {/*  </Button>*/}
      {/*</div>*/}
    </div>
  );
};

export default Filter;
